import React from 'react';
import { Box, Stack, Text } from '@mantine/core';
import { AfaFileList } from '../AfaFileList';

export interface AfaDocumentHistoryProps {
  /** Lista de documentos */
  documents: any[];

  /** Altura máxima del contenedor */
  maxHeight?: string | number;

  /** Espacio entre elementos */
  gap?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';

  /** Mensaje cuando no hay documentos */
  emptyMessage?: string;

  /** Estilos personalizados */
  style?: React.CSSProperties;

  /** Función para descargar */
  onDownload: (fileName: string, content: string) => void;
}

/** 
 * Convierte extensiones en un tipo válido para AfaFileList 
 */
const mapExtension = (
  ext: string
): "pdf" | "doc" | "xls" | "ppt" | "png" | "jpg" | "other" => {
  const e = ext.toLowerCase();

  if (e === "pdf") return "pdf";
  if (["doc", "docx"].includes(e)) return "doc";
  if (["xls", "xlsx"].includes(e)) return "xls";
  if (["ppt", "pptx"].includes(e)) return "ppt";
  if (["png"].includes(e)) return "png";
  if (["jpg", "jpeg"].includes(e)) return "jpg";

  return "other";
};

export const AfaDocumentHistory = ({
  documents,
  maxHeight = '200px',
  gap = 'md',
  emptyMessage = 'No hi ha documents de AFA per mostrar.',
  style,
  onDownload,
}: AfaDocumentHistoryProps) => {
  return (
    <Box
      bg="brand.0"
      p="md"
      style={{
        borderRadius: '8px',
        ...style,
      }}
    >
      {documents.length === 0 ? (
        <Text size="sm" c="dimmed" ta="center">
          {emptyMessage}
        </Text>
      ) : (
        <Stack
          gap={gap}
          style={{
            maxHeight,
            overflowY: 'auto',
          }}
        >
          {documents.map((doc, index) => {
            const ext = doc.title.split(".").pop() || "";
            return (
              <AfaFileList
                key={index}
                variant="link"
                files={[
                  {
                    name: doc.title,
                    type: mapExtension(ext),
                    created: doc.created,
                  }
                ]}
                onClick={(e: any) => {
                  e.preventDefault();
                  onDownload(doc.title, doc.content);
                }}
              />
            );
          })}
        </Stack>
      )}
    </Box>
  );
};

export default AfaDocumentHistory;
